// inapi·mq 알림톡·문자 v1/v2 스위치(2026-10-27). 값은 inapi 설정 저장소(env_configs)에 둔다.
// on = v2, 그 밖(없음 포함) = v1. inapi·mq 가 15초마다 다시 읽는다.
// DKT 가 옛 API 를 끄면 v1 은 동작하지 않는다 — 그때 이 스위치를 지운다.

export const SERVICE_SWITCHES = [
  {
    key: "MSGD_ALIMTALK_SEND",
    label: "inapi 알림톡",
    v1: "v1 (DKT 옛 API 직접)",
    v2: "v2 (발송 서버)",
    scope: "상담 알림(counsel-api)·인증번호·상담 레포트·프로모션·NFT·써마지·open-api, crm 에서 v1 으로 둔 회사의 알림톡",
  },
  {
    key: "MQ_DKT_V2_SEND",
    label: "mq 알림톡·문자",
    v1: "v1 (DKT 옛 API 직접)",
    v2: "v2 (DKT 새 API 직접)",
    scope: "인증서 발급·재발송·이벤트·예약·수동 쿠폰 알림톡과 문자(인증서 대체 문자 포함). 브랜드메시지·친구톡은 해당 없음",
  },
];

export const SWITCH_PROPAGATION_SECONDS = 15;

/**
 * inapi GET /bizmsg/route-switches 응답 → 키별 { route, modifyAt, updatedBy }.
 * 응답에 없는 키는 v1(아직 한 번도 바꾸지 않음)으로 본다 — inapi·mq 도 값이 없으면 v1 이다.
 */
export function switchStates(data) {
  const rows = new Map(((data && data.switches) || []).map((r) => [r.key, r]));
  return Object.fromEntries(
    SERVICE_SWITCHES.map((s) => {
      const r = rows.get(s.key);
      return [s.key, { route: r && r.route === "v2" ? "v2" : "v1", modifyAt: (r && r.modifyAt) || null, updatedBy: (r && r.updatedBy) || null }];
    }),
  );
}

/** 이력 한 줄 → 표 행 */
export function historyRows(data) {
  const labels = Object.fromEntries(SERVICE_SWITCHES.map((s) => [s.key, s.label]));
  return ((data && data.history) || []).map((h, i) => ({
    key: `${h.at}-${i}`,
    at: h.at,
    service: labels[h.key] || h.key,
    change: `${h.before} → ${h.after}`,
    by: h.byName || h.byUsername || "-",
  }));
}
